import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTheme, Box, ShortText } from 'src/viewLayer/components/DesignSystem';

import loading from 'src/viewLayer/assets/images/loading.gif';
import { t } from 'src/viewLayer/helpers/translations';
import {
  redirect,
  getRedirectNodeReturnToUrl,
  getAutoLoginReturnToUrl
} from 'src/viewLayer/components/nodes/RedirectNode/redirectNodeHelpers';
import { RedirectNodeProps } from './types';

import 'src/viewLayer/components/nodes/RedirectNode/index.scss';

export const RedirectNode = ({ nodeConfig, userData }: RedirectNodeProps): JSX.Element => {
  const theme = useTheme();
  const { learnLang } = useParams();
  const [searchParams] = useSearchParams();

  const queryParams = Object.fromEntries(searchParams);
  const returnToURL = nodeConfig.skipAuth === true
    ? getRedirectNodeReturnToUrl({ nodeConfig, learnLang, queryParams })
    : getAutoLoginReturnToUrl({ nodeConfig, learnLang, queryParams, signinToken: userData.signin_token });

  useEffect(() => {
    redirect(returnToURL);
  });

  return (
    <Box className="RedirectNode">
      <Box className="redirect-wrapper" backgroundColor={ theme.color.surface.container.background }>
        <img className="redirect-gif" alt="Loading Gif" src={ loading } />
        <ShortText weight="strong">{t('common.redirect.text')}</ShortText>
      </Box>
    </Box>
  );
};
